export default __webpack_public_path__ + "static/kowalczuk-c1570178cb74bc769f3daa5cb61b7424.jpg";